import { setQueryParams, getApiUrl, getAuthToken, handleTokenExpiry } from ".";
import cryptoJS from "crypto-js";

const handleFetch = async (
  url,
  method,
  body,
  { params, contentType = "application/json" } = {}
) => {
  const headers = {
    "x-warehouse-token": getAuthToken(),
  };

  if (
    contentType === "application/json" &&
    ["POST", "PUT", "PATCH", "DELETE"].includes(method)
  ) {
    headers["Content-Type"] = contentType;
    body = JSON.stringify(body);
  }

  // Custom header generation logic from Axios code
  const clientId = "web-client";
  const clientSecret = "web-client-secret";
  const headerDate = new Date().toISOString();
  const baseURL = url.replace(getApiUrl(), "");
  const reqPath = "/api/v2/" + baseURL;

  let bodyForHash;
  if (["POST", "PUT", "DELETE"].includes(method)) {
    bodyForHash = body || "";
  } else {
    bodyForHash = "";
  }
  const md5hash = cryptoJS.MD5(bodyForHash);
  const headerMD5 = cryptoJS.enc.Base64.stringify(md5hash);
  const hmac = cryptoJS.algo.HMAC.create(cryptoJS.algo.SHA256, clientSecret);
  hmac.update(method);
  hmac.update(reqPath);
  hmac.update(contentType);
  hmac.update(headerDate);
  hmac.update(headerMD5);
  hmac.update(clientId);
  const hmacHash = hmac.finalize();
  const headerAuth = cryptoJS.enc.Base64.stringify(hmacHash);

  headers["x-authorization-timestamp"] = headerDate;
  headers["x-authorization-clientid"] = clientId;
  headers["x-authorization-content-md5"] = headerMD5;
  headers["authorization"] = headerAuth;

  try {
    const response = await fetch(
      `${getApiUrl()}/${url}${setQueryParams(params)}`,
      {
        method,
        mode: "cors",
        headers,
        body: method === "GET" || method === "HEAD" ? null : body,
      }
    );

    const data = await response.json();

    handleTokenExpiry(data);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const get = (url = "", options = {}) => handleFetch(url, "GET", null, options);
const post = (url = "", body, options = {}) =>
  handleFetch(url, "POST", body, options);
const put = (url = "", body, options = {}) =>
  handleFetch(url, "PUT", body, options);
const patch = (url = "", body, options = {}) =>
  handleFetch(url, "PATCH", body, options);
const deleteCall = (url = "", body, options = {}) =>
  handleFetch(url, "DELETE", body, options);

export { get, post, put, patch, deleteCall };
